import React from "react";
import { SideMenu, BackHeader, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
import { useAlert } from "react-alert";
import { useNavigate, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
const Input = styled("input")({
  display: "none",
});
const OrganizeTripCreate = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const [countryCode, setCountryCode] = React.useState("");
  const [addActivities, setAddActivities] = React.useState(false);
  const [totalDays, setTotalDays] = React.useState([1, 1, 1]);
  let newDays = [];
  const addDayHandler = () => {
    newDays.push(1);
    setTotalDays([...totalDays, ...newDays]);
  };
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    console.log(e.target.value);
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  // Add Trip Activities
  const [addTripActivitiesDate, setAddTripActivitiesDate] = React.useState("");
  const [addTripActivitiesDetails, setAddTripActivitiesDetails] =
    React.useState("");
  const [addTripActivitiesLoading, setAddTripActivitiesLoading] =
    React.useState(false);
  const addTripActivitiesDateRef = React.useRef();
  const addTripActivitiesDetailsRef = React.useRef();
  const AddTripActivitiesHandler = () => {
    if (addTripActivitiesDate === "") {
      alert.error(<div className="alert-message">please select date</div>);
      addTripActivitiesDateRef.current.focus();
    } else if (addTripActivitiesDetails === "") {
      alert.error(<div className="alert-message">please add description</div>);
      addTripActivitiesDetailsRef.current.focus();
    } else {
      setAddTripActivitiesLoading(true);
      const AddTripActivitiesObject = {
        date: addTripActivitiesDate,
        details: addTripActivitiesDetails,
      };
      alert.success(
        <div className="alert-message">you have successfully save</div>
      );
      console.log(AddTripActivitiesObject);
      setTimeout(() => {
        setAddActivities(false);
        setAddTripActivitiesLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">
          {location.state.type === "add"
            ? "Organize Trip"
            : "Edit  Organize Trip"}
        </p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Trip Title</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter title"
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Trip Description</p>
                <textarea
                  className="textarea"
                  placeholder="Enter your Event descriptions"
                  rows="20"
                  cols="40"
                ></textarea>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Country</p>
                <select className="input">
                  <option value="">Country</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">State</p>
                <select className="input">
                  <option value="">State</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">City</p>
                <select className="input">
                  <option value="">City</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Mobile Number</p>
                <div className="country-code-picker-main">
                  <div className="country-code-picker-dropdown-main">
                    <select
                      className="country-code-picker-dropdown"
                      onChange={handleDropdownChange}
                    >
                      <option value="">Select</option>
                      {Countries.map((countriesValue, countriesIndex) => {
                        return (
                          <option
                            key={countriesIndex}
                            value={countriesValue.alpha2Code}
                          >
                            {`${countriesValue.callingCode}  ${countriesValue.name}`}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="country-flag-main">
                    {Countries.map((countriesFlagValue, countriesFlagIndex) => {
                      return (
                        <div key={countriesFlagIndex}>
                          {countriesFlagValue.alpha2Code === countryCode && (
                            <img
                              src={countriesFlagValue.flag}
                              className="country-flag"
                            />
                          )}
                        </div>
                      );
                    })}

                    <input
                      type="number"
                      className="mobile-number-input"
                      placeholder="Enter your mobile number"
                    />
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Trip type</p>
                <select className="input">
                  <option value="International">International</option>
                  <option value="day trip">Day Trip</option>
                  <option value="Overnight">Overnight</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Price</p>
                <input
                  type="number"
                  className="input"
                  placeholder="Add price"
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Destination</p>
                <input type="text" className="input" placeholder="Address" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Email ID</p>
                <input
                  type="email"
                  className="input"
                  placeholder="Enter email ID"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Enter tutor name</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter tutor name"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Start date</p>
                <input type="date" className="input" placeholder="dd/mm/yyyy" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">End date</p>
                <input type="date" className="input" placeholder="dd/mm/yyyy" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">
                  upload your organize Trip thumbnail
                </p>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">
                  upload your organize Trip Brochure
                </p>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Add Trip Activities</p>
                {totalDays.map((totalDaysValue, totalDaysIndex) => {
                  return (
                    <div className="organize-trip-activities-list-container">
                      <div
                        className="organize-trip-activities-main"
                        key={totalDaysIndex}
                      >
                        <p className="organize-trip-activities-heading">
                          Day {totalDaysIndex + 1}
                        </p>
                        <Button onClick={() => setAddActivities(true)}>
                          <p className="add-button-text">+ Add Activities</p>
                        </Button>
                      </div>
                      <div className="organize-trip-activities-show-container">
                        <p className="organize-trip-activities-show-date">
                          17/03/2022
                        </p>
                        <p className="organize-trip-activities-show-details">
                          Sed commodo sit amet leo non dapibus. Donec sit amet
                          metus quis nunc imperdiet dapibus. Pellentesque vel
                          odio bibendum ante euismod iaculis.Sed commodo sit
                          amet leo non dapibus. Donec sit amet metus quis nunc
                          imperdiet dapibus. 
                        </p>
                        <Button className="organize-trip-activities-delete-button">
                          <IoClose color="#000" size={20} />
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Button onClick={addDayHandler}>
                <p className="add-button-text">+ Add Day</p>
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                {location.state.type === "add" ? "Create Trip" : "Update Trip"}
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
      <Model
        modelTitle="Add Trip Activities"
        width="md"
        onClose={() => setAddActivities(false)}
        open={addActivities}
        buttonTitle="add"
        buttonHandler={AddTripActivitiesHandler}
        loading={addTripActivitiesLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Enter Date</p>
                  <input
                    type="date"
                    className="input"
                    placeholder="dd/mm/yyyy"
                    value={addTripActivitiesDate}
                    ref={addTripActivitiesDateRef}
                    onChange={(e) => setAddTripActivitiesDate(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Enter Details</p>
                  <textarea
                    className="textarea"
                    placeholder="enter Details"
                    rows="20"
                    cols="40"
                    value={addTripActivitiesDetails}
                    ref={addTripActivitiesDetailsRef}
                    onChange={(e) =>
                      setAddTripActivitiesDetails(e.target.value)
                    }
                  ></textarea>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default OrganizeTripCreate;
